export default __webpack_public_path__ + "static/media/saas.12d4fd6b.svg";